import { useState } from "react";
import {
	DropdownMenu,
	DropdownMenuTrigger,
	DropdownMenuContent,
	DropdownMenuItem,
} from "@/ui/dropdownMenu/DropdownMenu";

import style from "./MoreOptions.module.css";

import { successToast } from "@/ui/toast/Toast";
import i18n from "@/i18n";
import { useTranslation } from "react-i18next";
import Icon from "@/ui/icon/Icon";
import { useDeleteCourseReview } from "../../hooks/useDeleteCourseReview";

function MoreOptions({ course }) {
	const { t } = useTranslation();
	const { save } = useDeleteCourseReview({ course });

	const handleReviewDelete = async () => {
		await save();
		successToast(i18n.t("reviews:moreOptions.deleted"));
	};

	return (
		<DropdownMenu>
			<DropdownMenuTrigger className={style.moreBtn}>
				<Icon icon="fa-ellipsis" />
			</DropdownMenuTrigger>
			<DropdownMenuContent className={style.menu}>
				<DropdownMenuItem
					className={style.item}
					onSelect={handleReviewDelete}
				>
					<Icon icon="fa-trash" />
					<span>{t("common:actions.delete")}</span>
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}

export default MoreOptions;
